import PropTypes from 'prop-types';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import goldenRatio from '@glass/common/modules/goldenRatio/goldenRatio';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import MarkdownHeading from '@glass/shared/components/Content/MarkdownHeading';
import MarkdownLink from '@glass/shared/components/Content/MarkdownLink';
import MarkdownListItem from '@glass/shared/components/Content/MarkdownListItem';
import MarkdownParagraph from '@glass/shared/components/Content/MarkdownParagraph';
import getInternalHref from '@glass/shared/components/Content/getInternalHref';

const spacing = 3;

const useStyles = makeStyles()((theme) => ({
  root: {
    '& img': {
      maxWidth: '100%',
    },
    '& h1:not(:first-of-type),h2:not(:first-of-type),h3:not(:first-of-type),h4:not(:first-of-type),h5:not(:first-of-type),h6:not(:first-of-type)':
      {
        margin: theme.spacing(spacing, 0, spacing / goldenRatio),
      },
  },
}));

const components = {
  p: MarkdownParagraph,
  li: MarkdownListItem,
  h1: MarkdownHeading,
  h2: MarkdownHeading,
  h3: MarkdownHeading,
  h4: MarkdownHeading,
  h5: MarkdownHeading,
  h6: MarkdownHeading,
  a: MarkdownLink,
};

const linkTarget = (href) => {
  if (!getInternalHref(href)) {
    return '_blank';
  }
  return undefined;
};

function MarkdownContent({ children }) {
  const { classes } = useStyles();
  if (typeof children !== 'string') {
    return children;
  }
  return (
    <ReactMarkdown
      skipHtml
      className={classes.root}
      components={components}
      linkTarget={linkTarget}
    >
      {children}
    </ReactMarkdown>
  );
}

MarkdownContent.propTypes = {
  children: PropTypes.node,
};

MarkdownContent.defaultProps = {
  children: null,
};

export default MarkdownContent;
